import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate } from 'react-router-dom';
import { Result, Space, Typography, Button } from 'antd';
import LIEnquirySubmittedIcon from 'assets/images/Status-positive.svg';
import styled from 'styled-components';
import { useLastPayment } from 'hooks';
import { useEffect } from 'react';
import { localStorageService } from 'utils/LocalStorageService';

const ResponsiveDiv = styled.div`
  background: white;
  padding-top: 40px;
  margin-left: 160px;
  margin-right: 160px;

  @media (max-width: 768px) {
    padding: 0px;
    margin: 0px;
  }
`;

const ResponsiveDiv2 = styled.div`
  padding-left: 160px;
  padding-right: 160px;
  padding-top: 24px;
  padding-bottom: 24px;
  @media (max-width: 768px) {
    background: #c21b17;
    font-color: white;
    height: 80px;
    font-family: Roboto400;
    display: flex;
    align-items: center;
    padding-left: 10px;
    padding: 0px;
    margin: 0px;
  }
`;

const StyledTypographyText = styled(Typography.Text)`
  font-family: Roboto400;
  font-size: 33px;
  color: black;
  display: block;
  text-align: left;

  @media (max-width: 768px) {
    font-size: 26px;
    text-align: center;
    color: white;
    padding-left: 10px;
  }
`;

interface EnquiryData {
  paymentReference: string;
  paymentType: string;
}

export const SuccessPage = ({ paymentReference, paymentType }: EnquiryData) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { lastPayment } = useLastPayment();
  useEffect(() => {
    return () => {
      localStorageService.remove('LastPayment');
    };
  }, []);

  if (!paymentReference) {
    return <Navigate to="/notFound" replace={true} />;
  }

  return (
    <>
      <ResponsiveDiv2>
        <StyledTypographyText>
          {i18n.language === 'en' ? 'Upload Proof of Payment' : '上傳繳費證明'}
        </StyledTypographyText>
      </ResponsiveDiv2>
      <ResponsiveDiv style={{ background: 'white' }}>
        <Typography.Text
          style={{
            fontFamily: 'Roboto400',
            fontSize: '26px',
            color: '#6f7072',
            display: 'block',
            textAlign: 'center',
            paddingTop: '20px',
          }}
        >
          {paymentType === 'BANK_TRANSFER'
            ? t('Life.Policy.ProofPaymentReceived2')
            : paymentType === 'FPS'
            ? t('Life.Policy.ProofPaymentReceived3')
            : null}
        </Typography.Text>
        <Result
          icon={<img style={{ width: '153px', height: '153px' }} src={LIEnquirySubmittedIcon} />}
          extra={
            <Space direction="vertical">
              <div style={{ maxWidth: '640px' }}>
                <Typography.Text style={{ fontFamily: 'Roboto400', fontSize: '26px', color: '#6f7072' }}>
                  {paymentType === 'BANK_TRANSFER'
                    ? t('life.Payment.newBanner', { policyNumber: paymentReference })
                    : paymentType === 'FPS'
                    ? t('life.Payment.newBanner2')
                    : null}
                </Typography.Text>
              </div>
              {lastPayment?.inactiveAutoPayAccount == 'Y' && (
                <div style={{ maxWidth: '640px' }}>
                  <Typography.Text
                    style={{ fontFamily: 'Roboto400', fontSize: '18px', color: '#c21b17', whiteSpace: 'pre-line' }}
                  >
                    {t('life.Payment.successlabel3')}
                  </Typography.Text>
                </div>
              )}
              <Button
                block
                className="btn"
                type="primary"
                size="large"
                style={{
                  marginTop: '12px',
                  width: '80%',
                  height: '56px',
                  fontSize: '20px',
                  fontFamily: 'Roboto500',
                }}
                onClick={() =>
                  lastPayment?.inactiveAutoPayAccount == 'Y'
                    ? navigate('/ChangePaymentArrangement', { state: { policyNo: lastPayment?.policyNumber } })
                    : navigate('/LIPayment', { state: { tabs: 1 } })
                }
              >
                {lastPayment?.inactiveAutoPayAccount == 'Y' ? t('life.home.setupnow') : t('common.done')}
              </Button>
            </Space>
          }
        />
      </ResponsiveDiv>
    </>
  );
};
